import {
  _flexMixin,
  _setToDataProperty,
} from './_mapping-helper'
import {
  _getFirstNavItem, _permissionFilter
} from './_nav-maps'

export const utils = {
  flexMixin: _flexMixin,
  setToDataProperty: _setToDataProperty,
  permissionFilter: _permissionFilter,
  getFirstNavItem: _getFirstNavItem
}



// WEBPACK FOOTER //
// ./src/components/common/di-ding/utils.js